import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker?url'

GlobalWorkerOptions.workerSrc = pdfjsWorker

/**
 * Extract the text content of a PDF's first page, capped at maxChars.
 * Returns null on any read/parse failure so callers can fall back to
 * filename-based heuristics (content detection must fail open).
 */
export async function extractPdfFirstPageText(file: File, maxChars = 20000): Promise<string | null> {
  try {
    const data = await file.arrayBuffer()
    const pdf = await getDocument({ data }).promise
    try {
      const page = await pdf.getPage(1)
      const content = await page.getTextContent()
      const text = content.items
        .map(item => ('str' in item ? item.str : ''))
        .join(' ')
      return text.slice(0, maxChars)
    } finally {
      // Isolate cleanup: a destroy() rejection must not discard the text we
      // already captured (same pattern as countPdfPages).
      try { await pdf.destroy() } catch { /* cleanup failure — text already captured */ }
    }
  } catch {
    return null
  }
}
